import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleXmark,
  faCirclePause,
} from '@fortawesome/pro-regular-svg-icons';
import { Loader, ThemeIcon } from '@cowbell/ui/core';

interface AsyncTaskUnitStatusIconProps {
  readonly status: string;
}

/** Shared status glyph for async-task unit rows (chat card + task drawer). */
export function AsyncTaskUnitStatusIcon({
  status,
}: AsyncTaskUnitStatusIconProps) {
  if (status === 'completed') {
    return (
      <ThemeIcon size="xs" radius="xl" color="teal" variant="light">
        <FontAwesomeIcon icon={faCircleCheck} style={{ fontSize: 10 }} />
      </ThemeIcon>
    );
  }
  if (status === 'failed') {
    return (
      <ThemeIcon size="xs" radius="xl" color="red" variant="light">
        <FontAwesomeIcon icon={faCircleXmark} style={{ fontSize: 10 }} />
      </ThemeIcon>
    );
  }
  if (status === 'running') {
    return (
      <ThemeIcon size="xs" radius="xl" color="blue" variant="light">
        <Loader size={8} color="blue" />
      </ThemeIcon>
    );
  }
  return (
    <ThemeIcon size="xs" radius="xl" color="gray" variant="light">
      <FontAwesomeIcon icon={faCirclePause} style={{ fontSize: 10 }} />
    </ThemeIcon>
  );
}
